import { useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const FONT_FAMILY = "'Tajawal', 'Segoe UI', sans-serif";
const STORAGE_KEY = "hala_site_token";

export default function SiteGate({ children }) {
  const [status, setStatus] = useState("checking"); // checking | locked | unlocked
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const token = sessionStorage.getItem(STORAGE_KEY);
    if (!token) {
      setStatus("locked");
      return;
    }
    axios.post(`${API}/site-auth/check`, { token })
      .then(res => setStatus(res.data.valid ? "unlocked" : "locked"))
      .catch(() => setStatus("locked"));
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await axios.post(`${API}/site-auth/verify`, { username, password });
      if (res.data.authenticated) {
        if (res.data.token) sessionStorage.setItem(STORAGE_KEY, res.data.token);
        setStatus("unlocked");
      }
    } catch (err) {
      setError(err.response?.data?.detail || "بيانات الدخول غير صحيحة");
    } finally {
      setLoading(false);
    }
  };

  if (status === "checking") {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#0F172A", fontFamily: FONT_FAMILY }}>
        <div style={{ textAlign: "center", color: "white" }}>
          <div style={{ width: 40, height: 40, border: "3px solid rgba(255,255,255,0.2)", borderTopColor: "#1D8F4E", borderRadius: "50%", animation: "spin 0.8s linear infinite", margin: "0 auto 16px" }} />
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </div>
      </div>
    );
  }

  if (status === "unlocked") return children;

  return (
    <div dir="rtl" style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#0F172A", fontFamily: FONT_FAMILY, padding: 24 }}>
      <div style={{ backgroundColor: "#1E293B", borderRadius: 20, padding: "48px 36px", maxWidth: 380, width: "100%", boxShadow: "0 25px 50px rgba(0,0,0,0.4)", border: "1px solid #334155" }}>
        {/* Logo */}
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <div style={{ width: 64, height: 64, borderRadius: "50%", background: "linear-gradient(135deg, #1D8F4E, #15803D)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px", fontSize: 28, color: "white", fontWeight: "bold" }}>
            هـ
          </div>
          <h1 style={{ fontSize: 22, fontWeight: "bold", color: "white", margin: "0 0 6px", fontFamily: FONT_FAMILY }}>
            منصة هلا
          </h1>
          <p style={{ fontSize: 13, color: "#94A3B8", margin: 0, fontFamily: FONT_FAMILY }}>
            أدخل بيانات الدخول للمتابعة
          </p>
        </div>

        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: "block", fontSize: 13, color: "#94A3B8", marginBottom: 6, fontFamily: FONT_FAMILY }}>
              اسم المستخدم
            </label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              data-testid="site-gate-username"
              autoComplete="username"
              style={{
                width: "100%", padding: "14px 16px", fontSize: 15,
                backgroundColor: "#0F172A", border: "1px solid #334155", borderRadius: 10,
                color: "white", outline: "none", fontFamily: FONT_FAMILY, boxSizing: "border-box",
              }}
            />
          </div>

          <div style={{ marginBottom: 24 }}>
            <label style={{ display: "block", fontSize: 13, color: "#94A3B8", marginBottom: 6, fontFamily: FONT_FAMILY }}>
              كلمة المرور
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="site-gate-password"
              autoComplete="current-password"
              style={{
                width: "100%", padding: "14px 16px", fontSize: 15,
                backgroundColor: "#0F172A", border: "1px solid #334155", borderRadius: 10,
                color: "white", outline: "none", fontFamily: FONT_FAMILY, boxSizing: "border-box",
              }}
            />
          </div>

          {error && (
            <div style={{ backgroundColor: "rgba(239,68,68,0.1)", border: "1px solid rgba(239,68,68,0.3)", borderRadius: 8, padding: "10px 14px", marginBottom: 16, textAlign: "center" }}>
              <span style={{ fontSize: 13, color: "#EF4444", fontFamily: FONT_FAMILY }}>{error}</span>
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            data-testid="site-gate-login-btn"
            style={{
              width: "100%", padding: 16, backgroundColor: "#1D8F4E", color: "white",
              borderRadius: 10, border: "none", fontSize: 16, fontWeight: "bold",
              cursor: loading ? "default" : "pointer", fontFamily: FONT_FAMILY,
              opacity: loading ? 0.7 : 1, transition: "opacity 0.2s",
            }}
          >
            {loading ? "جاري التحقق..." : "دخول"}
          </button>
        </form>
      </div>
    </div>
  );
}
